import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=715f3d6c&scoped=true"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"
import style0 from "./newsPage.vue?vue&type=style&index=0&id=715f3d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f3d6c",
  null
  
)

export default component.exports